import { getAppEnvironment, getProjectId } from "./util/EnvironmentUtils";

const firebaseConfig =
	process.env.REACT_APP_FIREBASE_CONFIG &&
	JSON.parse(atob(process.env.REACT_APP_FIREBASE_CONFIG));

switch (getProjectId() || getAppEnvironment()) {
	case "qa":
	case "zenefleet-qa":
		firebaseConfig.authDomain = "api-qa.brightmile.io";
		break;
	case "staging":
	case "zenefleet-stage":
		firebaseConfig.authDomain = "api-stage.brightmile.io";
		break;
	default:
		firebaseConfig.authDomain = "api.brightmile.io";
		break;
}

const getFirebaseApp = async () => {
	const firebase = await getFirebaseNamespace();
	return firebase.app();
};

export const getFirebaseNamespace = async (): Promise<typeof firebase> => {
	if (window.firebase) {
		return window.firebase as any;
	}
	const firebase = (await import("firebase/compat/app")).default;
	await import("firebase/compat/auth");
	window.firebase = firebase as any;
	if (firebase.apps.length > 0) {
		return firebase;
	}
	if (!firebaseConfig) {
		throw new Error("[brightmile] Missing firebase config");
	}

	firebase.initializeApp(firebaseConfig);
	return firebase;
};

export const getFirebaseAuth = async () => {
	const app = await getFirebaseApp();
	if (!app) {
		return null;
	}
	if (app.auth) {
		return app.auth();
	}
	return app.auth();
};
